import { postForm as post, postFormData } from '@/utils/request'
import store from '@/store'

const UPDATE_ITEM_STATUS_V4 = '/item/itemv4/updateItemStatus'
const GET_ITEM_DETAIL_V4 = '/item/itemv4/detail'
// 菜品列表 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=608330561
const GET_ITEM_LIST_V4 = '/item/itemv4/list'
const GET_ITEM_LIST_BY_CATE_ID_V4 = '/item/itemv4/listByCateId'

const GET_ANCESTOR_ITEMS = '/item/itemv4/getAncestorItems'
// 查询菜品及其菜单品类信息 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=682837670
const GET_LIST_IDS_WITH_MENU_AND_CATE = '/item/itemv4/listIdsWithMenuAndCate'

// 获取菜品详情 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=688346055
const GET_ITEM_DETAIL_BY_IDS = '/item/itemv4/listbyids'

// 菜品功能灰度接口 https://mock.xiaojukeji.com/project/12401/interface/api/446117
const GET_ITEM_GRAYSCALE = '/item/common/getItemGrayscale'
// 获取套餐推荐价格 https://mock.xiaojukeji.com/project/12401/interface/api/485583
const GET_COMBO_PRICE = '/item/itemv4/getComboPrice'
// 设置菜品上架时间 https://mock.xiaojukeji.com/project/12401/interface/api/444545
const SET_AVAILABLE_TIMES = '/item/itemv4/setAvailableTimes'
// 取消菜品时间时间 https://mock.xiaojukeji.com/project/12401/interface/api/444591
const CANCEL_AVAILABLE_TIMES = '/item/itemv4/cancelAvailableTimeSetting'
// 获取问题菜品的id
const GET_PROBLEM_ITEM_IDS = '/item/diagnosis/getDiagnosisItemIDs'
// 菜品销量
const GET_ITEM_SALES_BY_IDS = '/item/itemv4/getItemSalesByIds' // mock地址：https://mock.xiaojukeji.com/mock/12401/
// 根据销量获取菜品列表
const GET_ITEM_LIST_WITH_SALES = '/item/itemv4/listWithSales'

const LIST_MENU_AND_CATE_WITH_DIAGNOSIS = '/item/itemv4/listMenuAndCateWithDiagnosis'
// 热销菜品校验
const GET_CHECK_HOT_PROMOTION_STATUS = '/item/itemv4/hotPromotionCheck'
// 获取菜品关键词列表export
const GET_ITEM_KEYWORD_LIST = '/item/itemv4/getItemKeyWordList'
// 获取高价菜
const GET_HIGH_PRICE_ITEM = '/item/itemv4/getHighPriceItemIDsV2'
// 获取管控菜详情
const GET_VERIFY_DETAIL_BY_CONTROL_ITEM_ID = '/item/itemv4/getVerifyDetailByControlItemID'

// 获取改价失败菜品
const GET_CHANGE_FAILED_REMINDER =
  '/gate/product/baselineItem/onlineItem/changePriceFailureReminder'

// 获取店铺堂食菜单信息
const GET_SHOP_OFFLINE_MENU_INFO = '/gate/item-biz/item/offlineMenu/getOfflineMenuByShopID'

// 上传图片||pdf
const UPLOAD_IMG_PDF = '/common/image/uploadImgPdf'

// 创建堂食菜单
const CREATE_OFFLINE_MENU = '/gate/item-biz/item/offlineMenu/create'
const GET_BASELINE_MENU_TYPE_AND_PDR = '/item/itemV4/getBaselineMenuTypeAndPDR'

const GET_ITEM_LIST = '/item/getItemListWithDetail'

const GET_COMMON_CONF = '/common/conf/get'
// 门店设置接口
const GET_SHOP_SETTING_INFO = '/shop/query/settingInfo'
// 获取加盟门店菜品权限
const GET_ITEM_AUTH_MAP = '/item/auth/getItemBrandAuthMap'

// 判断获取是否为openapi的shop
const CHECK_IS_OPENAPI_SHOP = `/shop/shop/isOpenApiShop`

export const getItemAuthMap = async params => {
  return postForm(GET_ITEM_AUTH_MAP, params)
}

export const getCommonConf = () => postForm(GET_COMMON_CONF)

export function getShopSettingInfo() {
  return postForm(GET_SHOP_SETTING_INFO)
}

export const getItemList = ({ itemName = '', itemStatus = 0, page = 1, pageSize = 10 }) =>
  postForm(GET_ITEM_LIST, {
    itemName,
    itemStatus,
    page,
    pageSize,
  })

// 封装菜品使用的公参
const postForm = (url, params) => {
  const channel = store.state.currentBusinessChannel
  return post(url, {
    ...params,
    businessChannel: channel,
  })
}

export const getBaselineMenuTypeAndPDR = async params => {
  return postForm(GET_BASELINE_MENU_TYPE_AND_PDR, params)
}
export const getItemInvalidKeywords = async params => {
  return postForm(GET_ITEM_KEYWORD_LIST, params)
}

export const getSalesItemList = async params => {
  return postForm(GET_ITEM_LIST_WITH_SALES, params)
}

export const getProblemItemIds = async params => {
  return postForm(GET_PROBLEM_ITEM_IDS, params)
}

// 添加菜品销量 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=1038546194
export const getItemSalesByIds = async params => {
  return postForm(GET_ITEM_SALES_BY_IDS, params)
}

export const updateItemStatusV4 = async params => {
  return postForm(UPDATE_ITEM_STATUS_V4, params)
}

export const getItemDetailV4 = async params => {
  return postForm(GET_ITEM_DETAIL_V4, params)
}

export const getItemListV4 = async params => {
  return postForm(GET_ITEM_LIST_V4, params)
}

export const getItemListByCateIdV4 = async params => {
  return postForm(GET_ITEM_LIST_BY_CATE_ID_V4, params)
}

export const getAncestorItems = async params => {
  return postForm(GET_ANCESTOR_ITEMS, params)
}

export const getListIdsWithMenuAndCate = async params => {
  return postForm(GET_LIST_IDS_WITH_MENU_AND_CATE, params)
}

export const getItemDetailByIds = async params => {
  return postForm(GET_ITEM_DETAIL_BY_IDS, params)
}

export const getItemGrayscale = async params => {
  return postForm(GET_ITEM_GRAYSCALE, params)
}

export const getComboPrice = async params => {
  return postForm(GET_COMBO_PRICE, params)
}

export const setAvailableTimes = async params => {
  return postForm(SET_AVAILABLE_TIMES, params)
}

export const cancelAvailableTimes = async params => {
  return postForm(CANCEL_AVAILABLE_TIMES, params)
}

export const checkHotPromotionStatus = async params => {
  return postForm(GET_CHECK_HOT_PROMOTION_STATUS, params)
}

export const getHighPriceItemIds = async params => {
  return postForm(GET_HIGH_PRICE_ITEM, params)
}
export const getVerifyDetailByControlItemID = async params => {
  return postForm(GET_VERIFY_DETAIL_BY_CONTROL_ITEM_ID, params)
}
export const getUpdatePriceTip = async params => {
  return postForm(GET_CHANGE_FAILED_REMINDER, params)
}

export const getShopOfflineMenuInfo = async params => {
  return postForm(GET_SHOP_OFFLINE_MENU_INFO, params)
}

export const uploadImgPdf = async params => {
  return postFormData(UPLOAD_IMG_PDF, {
    ...params,
    businessChannel: store.state.currentBusinessChannel,
  })
}

export const createOfflineMenu = async params => {
  return postForm(CREATE_OFFLINE_MENU, params)
}

export const listMenuAndCateWithDiagnosis = async params => {
  return postForm(LIST_MENU_AND_CATE_WITH_DIAGNOSIS, params)
}
/**
 * 判断是否为openapi shop 参数只需shopId 与 cityId 两个公参
 */
export const checkIsOpenapiShop = async () => {
  return postForm(CHECK_IS_OPENAPI_SHOP)
}
const GET_ONE_SHOP_INFO = '/auth/getShopByID'
// 登陆时获取必需的门店信息
export function getShopByID() {
  return postForm(GET_ONE_SHOP_INFO)
}
